import {Component, OnInit} from '@angular/core';

import {Router} from '@angular/router';

import {User,} from '../../_models/index';

import {AuthenticationService, ClientProfileService,} from '../../_services/index';

import {Role} from '../../helpers/role';
import {LoginHelper} from '../../helpers';
import {MatDialog} from "@angular/material/dialog";
import {MessageComponent} from "../message";

@Component({
    standalone: false,
    selector: "redirect",
    template: `<div class="redirect"></div>`
})

export class RedirectComponent implements OnInit {
    model: any = {};
    loading = false;
    currentUser: User;

    constructor(
        public router: Router,
        public authenticationService: AuthenticationService,
        public settingsService: ClientProfileService,
        public dialog: MatDialog) { }

    ngOnInit() {

      const tenantName = LoginHelper.getTenantName();
      if (tenantName == null || LoginHelper.getUserToken() == null){
          this.authenticationService.logout();

          return;
      }

      this.currentUser = JSON.parse(sessionStorage.getItem('currentUser'));

      if (this.currentUser.firstLogin && this.currentUser.active) {
        this.settingsService.getSettings(tenantName).subscribe(
          r => {
            let dialog = this.dialog.open(MessageComponent,
              {
                width: '250px',
                data: {
                  title: 'Legal Notice',
                  text: r.firstLoginNotice,
                  button: 'Acknowledge'
                }
              });
            dialog.afterClosed().subscribe(_ => this.redirect());
          }
        );
      } else {
        this.redirect();
      }
    }

    public redirect() {
      console.log('redirecting')
      if (this.currentUser.role == Role.KingAdmin){
        this.router.navigate(['/tenants']);
      } else if (this.currentUser.role == Role.Admin){
        this.router.navigate(['/controlItems']);
      } else if (this.currentUser.role == Role.IncidentResponse){
        this.router.navigate(['/incidentResponse']);
      } else if((this.currentUser.role & (Role.PrimaryAdvisorLead | Role.PrimaryManager)) != 0){
        if(this.currentUser.active == false){
          this.router.navigate(['/clientProfile'], {queryParams:{firstlogin:1}});
        } else {
          this.router.navigate(['/home']);
        }
      }
      else{
        this.router.navigate(['/home']);
      }
    }
}
